import emptySliceApi from '../../../shared/store/emptyApiSlice';
import { AddAlertRequest, CustomAlertResponse } from './models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomAccountAlerts: builder.query<CustomAlertResponse[], string>({
      query: (accountId) => `v4/accounts/${accountId}/alerts/custom`,
      providesTags: ['CustomAccountAlerts'],
    }),
    removeCustomAlert: builder.mutation<
      void,
      { accountId: string; alertId: string }
    >({
      query: ({ accountId, alertId }) => ({
        url: `v4/accounts/${accountId}/alerts/custom/${alertId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CustomAccountAlerts', 'AccountAlerts'],
    }),
    addCustomAlert: builder.mutation<
      void,
      { accountId: string; body: AddAlertRequest }
    >({
      query: ({ accountId, body }) => ({
        url: `v4/accounts/${accountId}/alerts/custom`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CustomAccountAlerts', 'AccountAlerts'],
    }),
  }),
});

export const {
  useGetCustomAccountAlertsQuery,
  useRemoveCustomAlertMutation,
  useAddCustomAlertMutation,
} = apiSlice;
